/* hgn-infinite-scroll.js — HGN's own infinite scroll for collection and
   search grids (replaces the Scrollify app). v1, 2026-10-02.
   Runbook: perf-v1/BUILD.md §10. Config: snippets/hgn-infinite-scroll.liquid
   (window.HGN_IS). Off unless that snippet is rendered with enabled: true.

   Progressive enhancement: Shopify's pagination stays in the HTML (crawlers
   and no-JS keep it). This file hides it, puts a "Load more" block in its
   place (same height, so nothing moves) and appends the next pages:
     · the next page is fetched when the block comes within FAR_PX of the
       viewport and appended at NEAR_PX (two IntersectionObservers), so the
       rows land below the fold; CFG.autoPages pages load by themselves,
       then the button only, so the footer can be reached;
     · Section Rendering of the SAME section (#product-grid[data-id]), so
       every card is the theme's own card-product markup;
     · one fetch at a time, aborted by a facets.js swap (filter / sort /
       Tier 1 / clear), which resets the scroller on the new grid;
     · never appends a product already in the grid (page 1's pulled-up
       products in arm B, whether or not the worker answered), nor one of
       page 1's ids that hgn-perf-rank hides on page 2+ (HGN.perfRank.hide);
       kit clones (li[data-hgn-kit-placed]) are never counted or touched;
     · arm B, page 1 ranked: page 1's displaced products (removed by the
       ranker) are put back at the head of the first append, as the
       paginated page 2 does (its "prepend"), from a Section Rendering of
       page 1. Arm A has no memory, so it sees exactly Shopify's sequence;
     · ?page= follows the rows in view (history.replaceState, keeping
       facets.js's state); after a reload / non-bfcache back the product
       that was in view is scrolled back into place;
     · after each append: hgn:grid:augmented (offer prices), the beacon's
       collection_append event (what was appended, in order), wishlist
       hearts painted, and on /search the tier tabs' data-tier + counts.
   Stands down if the Scrollify embed is on the page (two scrollers fight).
   Batch 4 (26 Oct 2026): no layout reads after init outside a frame's own
   layout: "near the block" comes from the observers, the ?page= tracker
   reads after the next paint.
   ES5, no dependencies. Debug handle: window.HGN.infiniteScroll. */
(function () {
  'use strict';
  var CFG = window.HGN_IS;
  if (!CFG || !CFG.on || window.__hgnIsLoaded) return;
  window.__hgnIsLoaded = true;
  var H = window.HGN = window.HGN || {};
  var S = H.infiniteScroll = {
    v: 1, state: 'init', base: 0, page: 0, last: 0, auto: 0, fails: 0, gen: 0,
    busy: false, swaps: 0, loads: [], log: [], standdown: null
  };
  var AUTO_PAGES = CFG.autoPages >= 0 ? CFG.autoPages : 3;
  /* Two distances below the viewport: the next page is FETCHED when the
     block comes within FAR, and APPENDED when it comes within NEAR, so the
     network wait is spent while the block is still well off-screen and the
     new rows land below the fold (a row pushed while the block is on screen
     would be a layout shift). Nothing is fetched before the shopper's first
     scroll, so a tall desktop window never fetches page 2 on load. */
  var VH = window.innerHeight || 800;
  var FAR_PX = Math.round(Math.min(VH * 4, 3200));
  var NEAR_PX = Math.round(Math.min(VH * 1.25, 1100));
  var scrolled = false;
  var TIMEOUT_MS = 10000;
  var TXT = { more: 'Load more', loading: 'Loading\u2026' };
  function now() { return Math.round(performance.now()); }
  function log(kind, x) { try { var e = { t: now(), kind: kind }; for (var k in x) if (Object.prototype.hasOwnProperty.call(x, k)) e[k] = x[k]; S.log.push(e); if (S.log.length > 200) S.log.shift(); } catch (err) {} }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  /* One-tab switch for checks: ?hgn_is=0 turns it off for the tab
     (remembered), ?hgn_is=1 clears that. */
  try {
    var qs = new URLSearchParams(location.search).get('hgn_is');
    if (qs === '0') ssSet('hgn:is:off', '1');
    else if (qs === '1') sessionStorage.removeItem('hgn:is:off');
  } catch (e) {}
  if (ssGet('hgn:is:off') === '1') { S.state = 'off'; S.standdown = 'tab switch'; return; }
  /* The Scrollify app embed: its inline asset map runs while the page
     parses, before this deferred file. */
  if (window.ScrollifyAssets || document.querySelector('script[src*="ultimate-infinite-scroll"], #gscollectionbottom')) {
    S.state = 'standdown'; S.standdown = 'scrollify'; log('standdown', { why: 'scrollify' }); return;
  }

  /* ── URLs ────────────────────────────────────────────────────────── */
  var STRIP = { page: 1, section_id: 1, hgn_is: 1 };
  function params(keepTest) {
    var out = new URLSearchParams();
    try { new URLSearchParams(location.search).forEach(function (v, k) { if (!STRIP[k] || (keepTest && k === 'hgn_is')) out.append(k, v); }); } catch (e) {}
    return out;
  }
  /* the Section Rendering URL of page n (same path, same filters / sort / q) */
  function sectionUrl(n) {
    var q = params(false);
    if (n > 1) q.set('page', String(n));
    q.set('section_id', S.sectionId);
    return location.pathname + '?' + q.toString();
  }
  /* the address bar for page n */
  function addressFor(n) {
    var q = params(true);
    var s = q.toString();
    var pg = n > 1 ? 'page=' + n : '';
    return location.pathname + ((pg || s) ? '?' + [pg, s].filter(Boolean).join('&') : '') + location.hash;
  }
  function urlPage() { try { return parseInt(new URLSearchParams(location.search).get('page') || '1', 10) || 1; } catch (e) { return 1; } }
  function facetKey() {
    var f = [];
    try { new URLSearchParams(location.search).forEach(function (v, k) { if (k.indexOf('filter.') === 0) f.push(k + '=' + v); }); } catch (e) {}
    f.sort();
    return f.join('&');
  }
  function sortParam() { try { return new URLSearchParams(location.search).get('sort_by') || ''; } catch (e) { return ''; } }

  /* ── the grid ────────────────────────────────────────────────────── */
  function isKit(li) { return li.hasAttribute('data-hgn-kit-placed'); }
  function idOf(li) {
    var el = li && li.querySelector && li.querySelector('[data-product-id]');
    var id = el ? String(el.getAttribute('data-product-id') || '') : '';
    if (!id && li && li.getAttribute) id = String(li.getAttribute('data-hgn-perf-inserted') || '');
    return /^\d+$/.test(id) ? id : '';
  }
  function kids(g) { return Array.prototype.filter.call(g.children, function (el) { return el.tagName === 'LI'; }); }
  /* every product already in the grid (visible or hidden), plus page 1's
     ids hgn-perf-rank hides on page 2+; never a kit clone */
  function seenSet() {
    var s = {};
    kids(S.grid).forEach(function (li) { if (!isKit(li)) { var id = idOf(li); if (id) s[id] = 1; } });
    var R = H.perfRank;
    ((R && R.hide) || []).forEach(function (id) { s[String(id)] = 1; });
    return s;
  }
  function readPagination(root) {
    var wrap = root && root.querySelector('.pagination-wrapper');
    var cur = 0, last = 0;
    if (wrap) {
      var c = wrap.querySelector('[aria-current="page"], .current');
      if (c) cur = parseInt(c.textContent, 10) || 0;
      Array.prototype.forEach.call(wrap.querySelectorAll('a[href]'), function (a) {
        var m = /[?&]page=(\d+)/.exec(a.getAttribute('href') || '');
        if (m) last = Math.max(last, parseInt(m[1], 10));
      });
      last = Math.max(last, cur);
    }
    return { wrap: wrap, cur: cur, last: last };
  }

  /* ── the block that replaces the pagination ──────────────────────── */
  function buildBlock(height) {
    var b = document.createElement('div');
    b.className = 'hgn-is';
    b.setAttribute('data-hgn-is', '');
    if (height > 0) b.style.minHeight = height + 'px';
    b.innerHTML = '<button type="button" class="hgn-is__more" data-hgn-is-more>' + TXT.more + '</button><span class="hgn-is__sr" role="status" aria-live="polite"></span>';
    b.querySelector('[data-hgn-is-more]').addEventListener('click', function () { loadNext('button'); });
    return b;
  }
  function setUi(state, say) {
    var b = S.block;
    if (!b) return;
    b.setAttribute('data-state', state);
    var btn = b.querySelector('[data-hgn-is-more]');
    if (btn) {
      var t = state === 'loading' ? TXT.loading : TXT.more;
      if (btn.textContent !== t) btn.textContent = t;
      btn.disabled = state === 'loading' || state === 'done';
      btn.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
    }
    if (say != null) { var sr = b.querySelector('.hgn-is__sr'); if (sr) sr.textContent = say; }
  }
  function autoAllowed() { return S.auto < AUTO_PAGES && !S.autoOff; }
  /* Batch 4 (26 Oct 2026): "is the block within px of the screen" comes
     from the two observers' last entries (S.seen[px]: intersecting, or
     already above the screen, the same test as the rect read), so it
     costs nothing. The rect read forced a layout of the whole page each
     time it ran on a dirty one, e.g. straight after an append (recorder:
     111 slow views led by this file, forced layout up to 10 s). It is
     only the fallback before an observer's first report. */
  function within(px) {
    if (!S.block) return false;
    if (S.seen && S.seen[px] != null) return S.seen[px];
    return S.block.getBoundingClientRect().top < (window.innerHeight || 800) + px;
  }
  /* fresh entries for the block after the browser's next layout (observe()
     always reports once): after an append, instead of reading its rect */
  function reobserve() {
    if (!S.block) return;
    S.seen = {};
    ios.forEach(function (o) { try { o.unobserve(S.block); o.observe(S.block); } catch (e) {} });
  }

  /* ── init / reset ────────────────────────────────────────────────── */
  var ios = [];
  function unobserve() { ios.forEach(function (o) { try { o.disconnect(); } catch (e) {} }); ios = []; }
  function init(reason) {
    S.state = 'none';
    var g = document.getElementById('product-grid');
    if (!g || !g.getAttribute('data-id') || g.tagName !== 'UL') { log('init', { why: 'no grid' }); return; }
    var pg = readPagination(g.parentNode);
    S.grid = g; S.sectionId = g.getAttribute('data-id');
    S.base = pg.cur || urlPage(); S.page = S.base; S.last = pg.last;
    S.auto = 0; S.autoOff = false; S.fails = 0; S.loads = []; S.busy = false; S.ctl = null; S.block = null; S.ready = null; S.want = null; S.seen = {};
    S.displacedDone = reason !== 'load'; /* page 1's displaced: the first view of page 1 only */
    if (!pg.wrap || pg.last <= 1) { S.state = 'single'; log('init', { why: 'one page' }); return; }
    if (S.page >= S.last) { S.state = 'last'; log('init', { why: 'last page', page: S.page }); return; }
    /* the address bar can disagree with the grid after a facets popstate */
    if (urlPage() !== S.base) setAddress(S.base);
    var h = pg.wrap.offsetHeight;
    var block = buildBlock(h);
    pg.wrap.parentNode.insertBefore(block, pg.wrap.nextSibling);
    pg.wrap.classList.add('hgn-is-paged');
    S.paged = pg.wrap; S.block = block;
    S.state = 'ready';
    setUi('idle');
    log('init', { reason: reason, base: S.base, last: S.last, section: S.sectionId });
    if ('IntersectionObserver' in window) {
      [[FAR_PX, 'prefetch'], [NEAR_PX, 'auto']].forEach(function (x) {
        var o = new IntersectionObserver(function (es) {
          var e = es[es.length - 1];
          if (S.seen) S.seen[x[0]] = e.isIntersecting || e.boundingClientRect.top < 0;
          /* after an append (S.loads) it carries on as the rect check did, scrolled or not */
          for (var i = 0; i < es.length; i++) if (es[i].isIntersecting && autoAllowed() && (scrolled || S.loads.length)) { loadNext(x[1]); break; }
        }, { rootMargin: '0px 0px ' + x[0] + 'px 0px' });
        o.observe(block);
        ios.push(o);
      });
    } else {
      S.autoOff = true; /* no observer: the button only */
    }
  }
  function teardown() {
    S.gen++;
    if (S.ctl) { try { S.ctl.abort(); } catch (e) {} }
    S.ctl = null; S.busy = false; S.ready = null; S.want = null;
    unobserve();
    if (S.block && S.block.parentNode) S.block.parentNode.removeChild(S.block);
    if (S.paged && document.contains(S.paged)) S.paged.classList.remove('hgn-is-paged');
    S.block = null; S.paged = null;
    setRestore('auto');
  }
  function reset(reason) {
    teardown();
    S.swaps++;
    log('reset', { reason: reason });
    init(reason);
  }
  /* Too many failures: give the shopper Shopify's pagination back. */
  function giveUp(why) {
    teardown();
    S.state = 'failed';
    log('failed', { why: why });
  }

  /* ── loading ─────────────────────────────────────────────────────── */
  function fetchDoc(n, ctl) {
    var t = setTimeout(function () { try { ctl.abort(); } catch (e) {} }, TIMEOUT_MS);
    return fetch(sectionUrl(n), { credentials: 'same-origin', signal: ctl.signal })
      .then(function (r) { clearTimeout(t); if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var g = doc.getElementById('product-grid');
        if (!g) throw new Error('no grid in the answer');
        return doc;
      }, function (e) { clearTimeout(t); throw e; });
  }
  /* arm B with page 1 ranked: what the ranker took off page 1 (its memory
     key is hgn-perf-rank's: hgn:perf:p1:<collection>|<sorted filters>) */
  function displacedIds(seen) {
    if (S.displacedDone || S.base !== 1) return [];
    S.displacedDone = true;
    var R = H.perfRank;
    if (!R || !R.cfg || !R.last || R.last.action !== 'order' || !R.last.changed) return [];
    var arm = R.arm || lsGet('hgn_arm_perf');
    if (arm !== 'B') return [];
    var sort = sortParam();
    if (sort && sort !== (R.cfg.dsort || '')) return [];
    var mem = null;
    try { mem = JSON.parse(ssGet('hgn:perf:p1:' + R.cfg.collection + '|' + facetKey()) || 'null'); } catch (e) {}
    var out = [];
    ((mem && mem.drop) || []).forEach(function (id) { id = String(id); if (/^\d+$/.test(id) && !seen[id] && out.indexOf(id) === -1) out.push(id); });
    return out.slice(0, 24);
  }
  var waits = 0;
  /* trigger: 'prefetch' (FAR: fetch only), 'auto' (NEAR: append), 'button' */
  function loadNext(trigger) {
    if (S.state !== 'ready' || !S.grid) return;
    var wants = trigger !== 'prefetch';
    /* fetched ahead: append now */
    if (wants && S.ready && S.ready.n === S.page + 1) { var rd = S.ready; S.ready = null; commit(rd.n, rd.r, trigger, rd.ms); return; }
    /* in flight: append the moment it lands */
    if (S.busy) { if (wants) { S.want = trigger; setUi('loading'); } return; }
    if (S.ready) return;
    var R = H.perfRank;
    /* hgn-perf-rank still holding page 1: its answer decides what was displaced */
    if (R && R.state === 'pending' && waits < 6) { waits++; setTimeout(function () { loadNext(trigger); }, 150); return; }
    var n = S.page + 1;
    if (n > S.last) { done(); return; }
    S.busy = true;
    S.want = wants ? trigger : null;
    if (wants) setUi('loading');
    var gen = S.gen;
    var ctl = typeof AbortController === 'function' ? new AbortController() : { signal: undefined, abort: function () {} };
    S.ctl = ctl;
    var t0 = now();
    var displaced = displacedIds(seenSet());
    log('fetch', { page: n, trigger: trigger, displaced: displaced.length });
    var pre = displaced.length
      ? fetchDoc(1, ctl).then(function (d1) {
        var byId = {};
        kids(d1.getElementById('product-grid')).forEach(function (li) { var id = idOf(li); if (id) byId[id] = li; });
        return displaced.map(function (id) { return byId[id]; }).filter(Boolean);
      })
      : Promise.resolve([]);
    pre.then(function (pl) { return fetchDoc(n, ctl).then(function (doc) { return { pre: pl, doc: doc }; }); })
      .then(function (r) {
        if (gen !== S.gen) return;
        S.ctl = null; S.busy = false; S.fails = 0;
        var ms = now() - t0;
        var w = S.want;
        S.want = null;
        /* asked for, or already close: append; otherwise hold it for NEAR */
        if (w || within(NEAR_PX)) commit(n, r, w || 'auto', ms);
        else { S.ready = { n: n, r: r, ms: ms }; log('ready', { page: n, ms: ms }); }
      })
      .catch(function (e) {
        if (gen !== S.gen) return; /* a facets swap aborted it: the new grid has its own scroller */
        var w = S.want;
        S.ctl = null; S.busy = false; S.want = null;
        S.fails++;
        log('error', { page: n, trigger: trigger, msg: String((e && e.message) || e) });
        if (S.fails >= 2) { giveUp(String((e && e.message) || e)); return; }
        S.autoOff = true; /* the button from now on */
        setUi('button');
        if (!w) log('prefetch failed', { page: n });
      });
  }
  function done() { S.state = 'done'; setUi('done'); unobserve(); log('done', { page: S.page }); }
  function prep(li, n, displaced) {
    /* the scroll-reveal animation classes come off, as on the kit clones
       and hgn-perf-rank's inserted cards (they would replay offscreen) */
    li.className = li.className.replace(/\banimate--[\w-]+\b|\bscroll-trigger(--[\w-]+)?\b/g, '').replace(/\s+/g, ' ').trim();
    li.removeAttribute('data-cascade');
    li.setAttribute('data-hgn-is-page', String(n));
    if (displaced) li.setAttribute('data-hgn-is-displaced', '1');
    Array.prototype.forEach.call(li.querySelectorAll('img'), function (img) {
      if (img.getAttribute('loading') !== 'lazy') img.setAttribute('loading', 'lazy');
      img.removeAttribute('fetchpriority');
    });
    /* card stylesheets the page already has */
    Array.prototype.forEach.call(li.querySelectorAll('link[rel="stylesheet"]'), function (l) {
      var href = l.getAttribute('href') || '';
      if (href && document.querySelector('link[rel="stylesheet"][href="' + href.replace(/"/g, '') + '"]')) l.parentNode.removeChild(l);
    });
    return li;
  }
  function commit(n, r, trigger, ms) {
    var seen = seenSet();
    var items = [], ids = [], skipped = 0;
    r.pre.forEach(function (li) {
      var id = idOf(li);
      if (!id || seen[id]) return;
      seen[id] = 1; items.push(prep(li, n, true)); ids.push(id);
    });
    var g2 = r.doc.getElementById('product-grid');
    kids(g2).forEach(function (li) {
      var id = idOf(li);
      if (!id) return;
      if (seen[id]) { skipped++; return; }
      seen[id] = 1; items.push(prep(li, n, false)); ids.push(id);
    });
    var pg = readPagination(g2.parentNode);
    S.last = pg.wrap ? Math.max(pg.last, n) : n;
    if (items.length) {
      var frag = document.createDocumentFragment();
      items.forEach(function (li) { frag.appendChild(document.adoptNode(li)); });
      S.grid.appendChild(frag);
    }
    S.page = n;
    if (trigger === 'auto' && items.length) S.auto++;
    S.loads.push({ page: n, ids: ids, skipped: skipped, ms: ms, trigger: trigger, displaced: r.pre.length });
    log('append', { page: n, n: items.length, skipped: skipped, ms: ms });
    afterAppend(n, items, ids, skipped, trigger);
    if (S.page >= S.last) { done(); return; }
    setUi(autoAllowed() ? 'idle' : 'button', items.length ? items.length + ' more products loaded' : null);
    /* the observers only report changes: if the block is still close (a
       short page, or everything was a duplicate), carry on from here.
       Batch 4: re-observing gets their fresh report after the browser has
       laid the new rows out itself; the observer callbacks then load the
       next page exactly as the rect check here used to. */
    setTimeout(function () {
      if (S.state !== 'ready') return;
      if (!items.length && trigger === 'button') loadNext('button');
      else if (autoAllowed()) reobserve();
    }, 0);
  }

  /* ── what other scripts need after an append ─────────────────────── */
  function afterAppend(n, items, ids, skipped, trigger) {
    if (!items.length) return;
    paintWishlist(items);
    if (CFG.template === 'search') searchTabs();
    try { document.dispatchEvent(new CustomEvent('hgn:grid:augmented', { bubbles: true, detail: { source: 'infinite-scroll', count: items.length, page: n } })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('hgn:infinite-scroll:appended', { detail: { page: n, ids: ids.slice(), grid: S.grid } })); } catch (e) {}
    /* the beacon (hgn-perf-beacon, when it is on): what the shopper now has
       in the grid, in order. Its own consent check and device id apply. */
    var B = H.perfBeacon;
    if (B && typeof B.send === 'function' && CFG.template === 'collection' && CFG.collection) {
      var filters = [];
      try { new URLSearchParams(location.search).forEach(function (v, k) { if (k.indexOf('filter.') === 0) filters.push(k + '=' + v); }); } catch (e) {}
      filters.sort();
      try { B.send('collection_append', { collection: CFG.collection, sort: sortParam(), filters: filters, pageNum: n, ids: ids.slice(0, 48), seq: S.loads.length, skipped: skipped, trigger: trigger }); } catch (e) {}
    }
  }
  /* Wishlist hearts: theme.liquid paints .wishlisted once, at
     DOMContentLoaded, on the hearts that exist then (its functions are
     private). The same sources: the guest list in localStorage, the
     hearts already painted, and for a signed-in customer the same
     wishlist API the theme reads (once per page). */
  var wishRemote = null;
  function wishIds() {
    var ids = {};
    Array.prototype.forEach.call(document.querySelectorAll('.wishlist-card-button.wishlisted[data-product-id]'), function (b) { ids[String(b.getAttribute('data-product-id'))] = 1; });
    try {
      var data = JSON.parse(lsGet('hgn_wishlist_temp') || 'null');
      var w = (data && data.wishlist) || {};
      Object.keys(w).forEach(function (t) { (Array.isArray(w[t]) ? w[t] : []).forEach(function (it) { if (it && it.id != null) ids[String(it.id)] = 1; }); });
    } catch (e) {}
    return ids;
  }
  function paintWishlist(items) {
    var paint = function (ids) {
      items.forEach(function (li) {
        Array.prototype.forEach.call(li.querySelectorAll('.wishlist-card-button[data-product-id]'), function (b) {
          if (ids[String(b.getAttribute('data-product-id'))] && !b.classList.contains('wishlisted')) b.classList.add('wishlisted');
        });
      });
    };
    paint(wishIds());
    var cust = CFG.customer || window.HGN_CUSTOMER_ID;
    if (!cust || typeof fetch !== 'function') return;
    if (!wishRemote) {
      wishRemote = fetch('https://wishlist.holygrailnail.com/api/wishlist/' + encodeURIComponent(String(cust)))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var ids = {};
          var w = (d && d.wishlist) || {};
          Object.keys(w).forEach(function (t) { (Array.isArray(w[t]) ? w[t] : []).forEach(function (it) { if (it && it.id != null) ids[String(it.id)] = 1; }); });
          return ids;
        })
        .catch(function () { return {}; });
    }
    wishRemote.then(paint);
  }
  /* /search: hgn-search-grid's tier tabs hide li:not([data-tier=x]) and
     count li.grid__item per tier; its stamp + count run on its own
     triggers only, so appended cards get the same stamp (its
     inferCardTier rule) and the counts are redone the same way. */
  function searchTabs() {
    var g = S.grid, root = g.closest('[data-hgn-search-grid], .shopify-section') || document;
    if (!document.querySelector('[data-hgn-tabs]')) return;
    var counts = { all: 0, classic: 0, gels: 0, 'press-ons': 0, accessories: 0 };
    Array.prototype.forEach.call(g.querySelectorAll('li.grid__item'), function (li) {
      if (isKit(li)) return; /* kit clones carry their card's tier; they are not results */
      if (!li.hasAttribute('data-tier')) {
        var el = li.querySelector('[data-product-type]');
        var t = (el && el.getAttribute('data-product-type') || '').toLowerCase();
        li.setAttribute('data-tier', t.indexOf('accessor') !== -1 || t.indexOf('starter kit') !== -1 ? 'accessories' : t.indexOf('gel') !== -1 ? 'gels' : t.indexOf('press') !== -1 ? 'press-ons' : 'classic');
      }
      var tier = li.getAttribute('data-tier') || 'classic';
      counts.all += 1;
      if (counts[tier] != null) counts[tier] += 1;
    });
    Object.keys(counts).forEach(function (tier) {
      var slot = root.querySelector('[data-hgn-tab-count="' + tier + '"]');
      if (slot && slot.textContent !== String(counts[tier])) slot.textContent = String(counts[tier]);
      var btn = root.querySelector('[data-hgn-tab="' + tier + '"]');
      if (btn) btn.hidden = (tier !== 'all' && counts[tier] === 0);
    });
  }

  /* ── ?page= follows the rows in view; restore after reload / back ── */
  function setRestore(mode) { try { if ('scrollRestoration' in history && history.scrollRestoration !== mode) history.scrollRestoration = mode; } catch (e) {} }
  function setAddress(n) {
    var a = addressFor(n);
    if (a === location.pathname + location.search + location.hash) return;
    try { history.replaceState(history.state, '', a); } catch (e) {}
  }
  function pageOfLi(li) {
    var p = li.getAttribute('data-hgn-is-page');
    if (p) return parseInt(p, 10);
    if (!isKit(li)) return S.base;
    for (var s = li.nextElementSibling; s; s = s.nextElementSibling) if (!isKit(s)) return pageOfLi(s);
    return S.page;
  }
  function liAt(y) {
    var x = Math.round((window.innerWidth || 360) / 2);
    for (var d = 0; d < 5; d++) {
      var el = document.elementFromPoint(x, y + d * 40);
      var li = el && el.closest && el.closest('#product-grid > li');
      if (li) return li;
      var el2 = document.elementFromPoint(Math.round(x / 2), y + d * 40);
      li = el2 && el2.closest && el2.closest('#product-grid > li');
      if (li) return li;
    }
    return null;
  }
  function track() {
    if (!S.grid || !S.loads.length || !document.contains(S.grid)) return;
    var y = Math.round((window.innerHeight || 700) * 0.35);
    var li = liAt(y), pg;
    if (li) pg = pageOfLi(li);
    else {
      var r = S.grid.getBoundingClientRect();
      if (r.bottom < y) pg = S.page; else if (r.top > y) pg = S.base; else return;
    }
    setAddress(pg);
    /* the browser's own restore is only right on the page the document
       was loaded as; past it, this file restores instead */
    setRestore(pg === S.base ? 'auto' : 'manual');
    if (li && !isKit(li)) {
      var id = idOf(li);
      if (id) ssSet('hgn:is:anchor', JSON.stringify({ key: location.pathname + '|' + params(false).toString(), page: pg, id: id, off: Math.round(li.getBoundingClientRect().top), at: Date.now() }));
    }
  }
  var trackT = null;
  /* Batch 4: track() reads positions (elementFromPoint, rects); run it just
     after the next frame has been laid out and painted, when those reads
     are free, rather than whenever the timer fires (often mid-change). */
  function afterPaint(fn) {
    if (!window.requestAnimationFrame) { fn(); return; }
    requestAnimationFrame(function () { setTimeout(fn, 0); });
  }
  window.addEventListener('scroll', function () {
    if (!scrolled) {
      scrolled = true;
      /* the observers' first report came before any scroll and was ignored */
      if (S.state === 'ready' && autoAllowed()) { if (within(NEAR_PX)) loadNext('auto'); else if (within(FAR_PX)) loadNext('prefetch'); }
    }
    if (trackT || !S.loads.length) return;
    trackT = setTimeout(function () { afterPaint(function () { trackT = null; track(); }); }, 200);
  }, { passive: true });
  function restore() {
    var nav = null;
    try { nav = performance.getEntriesByType('navigation')[0]; } catch (e) {}
    var type = nav ? nav.type : '';
    if ((type !== 'back_forward' && type !== 'reload') || S.base < 2) return;
    var a = null;
    try { a = JSON.parse(ssGet('hgn:is:anchor') || 'null'); } catch (e) {}
    if (!a || a.page !== S.base || a.key !== location.pathname + '|' + params(false).toString() || Date.now() - (a.at || 0) > 30 * 60 * 1000) return;
    /* The grid above the product still settles after this file runs (the
       chrome's toolbar re-layout, kit clones at slots 1 and 3, the late
       kit pass at load + 400 ms), so: once at load + 500 ms, then up to two
       corrections while the shopper hasn't scrolled themselves. */
    var lastY = -1;
    var go = function (pass) {
      if (!S.grid || !document.contains(S.grid)) return;
      if (pass > 0 && Math.abs(window.pageYOffset - lastY) > 2) return; /* the shopper moved */
      var li = null;
      kids(S.grid).forEach(function (x) { if (!li && !isKit(x) && idOf(x) === String(a.id)) li = x; });
      var top = li ? li.getBoundingClientRect().top - (a.off || 0) : (pass ? 0 : S.grid.getBoundingClientRect().top - 80);
      /* instant: the theme sets scroll-behavior: smooth on html */
      if (Math.abs(top) > 2 || pass === 0) {
        var y = Math.max(0, Math.round(window.pageYOffset + top));
        try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y); }
      }
      lastY = window.pageYOffset;
      log('restore', { id: a.id, found: Boolean(li), pass: pass, moved: Math.round(top) });
      if (pass < 2) setTimeout(function () { go(pass + 1); }, 700);
    };
    var begin = function () { setTimeout(function () { go(0); }, 500); };
    if (document.readyState === 'complete') begin(); else window.addEventListener('load', begin);
  }

  /* ── facets.js swaps #ProductGridContainer's children: reset ─────── */
  function watchSwaps() {
    var host = document.getElementById('ProductGridContainer');
    if (!host || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      var g = document.getElementById('product-grid');
      if (g && g === S.grid && document.contains(g)) return;
      reset('swap');
    }).observe(host, { childList: true });
  }

  function start() {
    init('load');
    restore();
    watchSwaps();
  }
  S.loadNext = loadNext;
  S.reset = reset;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
